<template>
  <transition name="modal-fade">
    <v-dialog :value="active" width="80vh" persistent>
      <v-card class="logWrap">
        <v-card-title primary-title>
          <h3>Cambiar contraseña</h3><br>
        </v-card-title>
        <v-card-text>
          <v-text-field
            :type="hidePasswordOld ? 'password' : 'text'"
            :append-icon="hidePasswordOld ? 'visibility_off' : 'visibility'"
            rounded
            dense
            filled
            name="oldPass"
            label="Contraseña Actual"
            id="oldPass"
            :rules="[rules.required]"
            v-model="oldPass"
            @click:append="hidePasswordOld = !hidePasswordOld"
          />
          <v-text-field
            :type="hidePasswordNew ? 'password' : 'text'"
            :append-icon="hidePasswordNew ? 'visibility_off' : 'visibility'"
            rounded
            filled
            dense
            name="newPass"
            label="Contraseña Nueva"
            id="newPass"
            :rules="[rules.required]"
            v-model="newPass"
            @click:append="hidePasswordNew = !hidePasswordNew"
          />
          <v-text-field
            :type="hidePasswordRepeat ? 'password' : 'text'"
            :append-icon="hidePasswordRepeat ? 'visibility_off' : 'visibility'"
            rounded
            dense
            filled
            name="repeatPass"
            label="Repetir Contraseña Nueva"
            id="repeatPass"
            :rules="[rules.required, rules.passLength, rules.passCapitalLetter, rules.passLowCaseLetter, rules.passNumber, rules.passSpecialCharacter]"
            v-model="repeatPass"
            @click:append="hidePasswordRepeat = !hidePasswordRepeat"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="confirm('confirmar')"
            class="white--text logWrap"
            color="#004283"
          >
            Confirmar
          </v-btn>
          <v-btn
            @click="confirm('cerrar')"
            class="white--text logWrap"
            color="#004283"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </transition>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rules: {
        required: value => !!value || "Campo requerido.",
        // equalPass: value =>
        //   (value == this.newPass && value == this.repeatPass) ||
        //   "Los campos 'Contraseña Nueva' y 'Repetir Contraseña Nueva' no son iguales",
        passLength: value =>
          (value.split("").length >= 8 && value.split("").length < 15) ||
          "La extensión de la contraseña deberá ser de entre 8 y 15 caracteres (ambos incluidos)",
        passCapitalLetter: value => value.match(/.*[A-Z].*/) || "La contraseña debe contener al menos una letra mayúscula",
        passLowCaseLetter: value => value.match(/.*[a-z].*/) || "La contraseña debe contener al menos una letra minúscula",
        passNumber: value => value.match(/.*[0-9].*/) || "La contraseña debe contener al menos un número",
        passSpecialCharacter: value => ('[`!@#$%^&*()_+-=[]{};\':"\\|,.<>/?~]').split('').some(sc => value.includes(sc)) || "La contraseña debe contener al menos un caracter especial"
      },
      oldPass: "",
      newPass: "",
      repeatPass: "",
      hidePasswordOld: true,
      hidePasswordNew: true,
      hidePasswordRepeat: true,
      user: this.$store.state.auth.user
    };
  },
  methods: {
    confirm(action) {
      if (action == "confirmar") {
        if (this.oldPass == undefined || /^\s*$/.test(this.oldPass)) {
          this.$emit("closeCP", "Campo 'Contraseña Actual' vacío");
        } else if (this.newPass == undefined || /^\s*$/.test(this.newPass)) {
          this.$emit("closeCP", "Campo 'Contraseña Nueva' vacío");
        } else if (
          this.repeatPass == undefined ||
          /^\s*$/.test(this.repeatPass)
        ) {
          this.$emit("closeCP", "Campo 'Repetir Contraseña Nueva' vacío");
        } else if (this.repeatPass.length < 8) {
          this.$emit(
            "closeCP",
            "La extensión de la contraseña deberá ser de 8 caracteres o más"
          );
        } else if (this.repeatPass.length > 15) {
          this.$emit(
            "closeCP",
            "La extensión de la contraseña deberá ser de 15 caracteres o menos"
          );
        } else if (!this.repeatPass.match(/.*[A-Z].*/)) {
          this.$emit(
            "closeCP",
            "La contraseña debe contener al menos una letra mayúscula"
          );
        } else if (!this.repeatPass.match(/.*[a-z].*/)) {
          this.$emit(
            "closeCP",
            "La contraseña debe contener al menos una letra minúscula"
          );
        }
        else if (!this.repeatPass.match(/.*[0-9].*/)) {
          this.$emit(
            "closeCP",
            "La contraseña debe contener al menos un número"
          );
        } else if(!('[`!@#$%^&*()_+-=[]{};\':"\\|,.<>/?~]').split('').some(sc => this.repeatPass.includes(sc)) ){
          this.$emit(
            "closeCP",
            "La contraseña debe contener al menos un caracter especial"
          );
        } else if (this.repeatPass != this.newPass) {
          this.$emit(
            "closeCP",
            "Los campos 'Contraseña Nueva' y 'Repetir Contraseña Nueva' no son iguales"
          );
        } else {
          this.$emit("closeCP", action, {
            id: this.user.id,
            oldPass: this.oldPass,
            newPass: this.newPass
          });
        }
      } else {
        this.$emit("closeCP", action);
      }
    },
    resetValues(){
        this.oldPass = "";
        this.newPass = "";
        this.repeatPass = "";
        this.hidePasswordNew = true;
        this.hidePasswordOld = true;
        this.hidePasswordRepeat = true;
    }
  }
};
</script>

<style scoped>
.logWrap {
  border-radius: 2em;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalChangePass.vue